<template>
  <div class="doctor-entry-page">

        <PageHeader icon="fas fa-user-md">
      <template #title>
        Tambah Dokter
      </template>
      <template #subtitle>
        Lengkapi identitas, kredensial, akun, dan informasi kontak dokter.
      </template>
    </PageHeader>
    <div class="row">
      <div class="col-md-12">
        

              <Form
                :form="form"
                :route="'doctors'"
                :password="true"
              />

            
      </div>
    </div>
  </div>
</template>

<script>

import Form from '@/component/doctors/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data() {
    return {
      form: {
        user_type_id: "1",
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        sip_number: "",
        sip_exp: window.medhopToday(),
        id_card_number: "",
        registration_number: "",
        mobile_phone: "",
        phone: "",
        address: "",
        polyclinic_id: null,
        photo: [],
        photo_name: "/images/default-profile.svg"
      }
    }
  },

  components: {
        Form
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dokter", route: "" },
      { title: "Daftar Dokter", route: "/doctor/list" },
      { title: "Tambah" },
    ])
  },

}

</script>
